import { useTranslation } from "react-i18next";
import useSearchDialogForm from "~/features/SearchV3/hooks/useSearchDialogForm";
import { useTabStore } from "~/stores";
import { SEARCH_TABS } from "~/types/search.types";

const TextSelectionInfo = () => {
    const { t } = useTranslation();
    const { selectedTopicIds, totalSelectedItems } = useSearchDialogForm();

    const activeTab = useTabStore(state => state.tab);
    const count =
        activeTab?.key === SEARCH_TABS.FULL_DOCUMENTS
            ? totalSelectedItems
            : selectedTopicIds.length;
    const transKey =
        activeTab?.key === SEARCH_TABS.FULL_DOCUMENTS
            ? "searchForm.popup.selectedCompaniesLabel"
            : "searchForm.popup.selectedTopicsLabel";

    return count > 0 && <span>{t(transKey, { count })}</span>;
};

export default TextSelectionInfo;
